import { get, isEmpty } from 'lodash'

const isLoading = state => get(state, 'vista360OrderMainTabLoad.loading')
const hasErrors = state => !isEmpty(get(state, 'vista360OrderMainTabLoad.error'))

export const selectors = {
  isLoading,
  hasErrors,
}
